<p-sidebar [(visible)]="visible" position="right"
           styleClass="w-35rem admsb-sidebar-editar admsb-sidebar-tarifas"
           [blockScroll]="true" [showCloseIcon]="true"
           [baseZIndex]="baseZIndex"
           [appendTo]="appendTo"
           (onHide)="cerrar()">

  <ng-template pTemplate="header">
    <span class="admsb-sidebar-editar__titulo">
      {{ 'ADMINISTRADORSERVICIOSBANCARIOS.TITULO_SIDEBAR_GESTIONAR_TARIFAS' | translate }}
    </span>
  </ng-template>

  <app-loading *ngIf="cargando || guardando"></app-loading>

  <div class="admsb-sidebar-tarifas__cuerpo" *ngIf="medio && !cargando && !guardando">
    <!-- Tarjeta Medio de Pago -->
    <div class="admsb-sidebar-tarifas__medio-card">
      <div class="admsb-sidebar-tarifas__medio-info">
        <div class="admsb-sidebar-tarifas__medio-avatar">
          <img [src]="iconoUrl" [alt]="medio?.nombreMedioPago || ''" class="admsb-sidebar-tarifas__medio-logo"
               (error)="onIconoError($event)">
        </div>
        <div class="admsb-sidebar-tarifas__medio-textos">
          <span class="admsb-sidebar-tarifas__medio-subtitulo">
            {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_MEDIODEPAGO' | translate | uppercase }}
          </span>
          <span class="admsb-sidebar-tarifas__medio-titulo">
            {{ medio?.nombreMedio || medio?.nombreMedioPago }}
          </span>
        </div>
      </div>
      <div class="admsb-sidebar-tarifas__medio-estado">
        <span class="badge-estado-medio"
              [ngClass]="medio?.indicadorHabilitado || medio?.codigoEstado === 'MEDACT' || medio?.codigoEstadoMedio === 'MEDACT' ? 'badge-activo' : (medio?.codigoEstado === 'MEDDEN' || medio?.codigoEstadoMedio === 'MEDDEN' || medio?.codigoEstado === 'DENEGA' || medio?.estado === 'DENEGADO' || medio?.estadoMedio?.toUpperCase() === 'DENEGADO' ? 'badge-denegado' : 'badge-inactivo')">
          {{ medio?.estado || medio?.estadoMedio }}
        </span>
      </div>
    </div>

    <!-- Tabla de Conceptos -->
    <div class="admsb-sidebar-tarifas__tabla-container">
      <table class="admsb-sidebar-tarifas__tabla">
        <thead>
          <tr>
            <th class="col-concepto">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONCEPTO' | translate }}</th>
            <th class="col-base text-center">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFABASE' | translate }}</th>
            <th class="col-asignada text-center">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFA_ASIGNADA' | translate }}</th>
            <th class="col-preferencial text-center">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFAPREFERENCIAL' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of conceptosTarifas">
            <td class="col-concepto font-medium">
              {{ c.labelClave | translate }}
            </td>
            <td class="col-base text-center">
              {{ formatearValorTarifa(c.tarifaBase, c.tipo) }}
            </td>
            <td class="col-asignada text-center">
              {{ formatearValorTarifa(c.tarifaAsignada, c.tipo) }}
            </td>
            <td class="col-preferencial text-center">
              <input type="text"
                     pInputText
                     autocomplete="off"
                     class="admsb-sidebar-tarifas__input"
                     number-format-reactive
                     [(ngModel)]="c.tarifaPreferencial"
                     (blur)="verificarTarifaIgualABase(c)"
                     [prefix]="prefijoTarifa(c.tipo)"
                     [suffix]="sufijoTarifa(c.tipo)"
                     [maxIntegerDigits]="maxEnterosTarifa(c.tipo)"
                     [maxDecimalDigits]="maxDecimalesTarifa(c.tipo)"
                     placeholder="0,0">
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Banner informativo azul -->
    <div class="admsb-sidebar-tarifas__banner-info">
      <i class="fa fa-info-circle admsb-sidebar-tarifas__banner-icono"></i>
      <span class="admsb-sidebar-tarifas__banner-texto">
        {{ 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_INFO_HEREDAR_TARIFA_BASE' | translate }}
      </span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="admsb-sidebar-editar__footer">
      <button type="button" pButton class="btn-primary-outline"
              [disabled]="guardando || cargando"
              label="{{ 'BTN_CANCELAR' | translate }}"
              (click)="cerrar()"></button>
      <button type="button" pButton class="btn-primary-full"
              [disabled]="guardando || cargando"
              icon="{{ guardando ? 'fa fa-refresh fa-spin fa-fw' : 'fa fa-floppy-o' }}"
              label="{{ 'BTN_GUARDAR' | translate }}"
              (click)="guardar()"></button>
    </div>
  </ng-template>
</p-sidebar>
